import { AbstractCommand } from 'src/models/command';

class DeleteTheColorSchemeCommand extends AbstractCommand {
	readonly name = 'IFS_Core_Command_Commands_DeleteTheColorSchemeCommand';

	public constructor(name: string) {
		super();
		this.parameters = {
			name: name,
		};
	}
}

export { DeleteTheColorSchemeCommand };
